import { alpha, createTheme, ThemeProvider, useTheme } from "@mui/material";
import { ReactNode, useMemo } from "react";

import { useContactCenterTheme } from "./ContactCenterThemeContext";

export function ContactCenterThemeScope({ children }: { children: ReactNode }) {
  const outerTheme = useTheme();
  const { theme } = useContactCenterTheme();

  const scopedTheme = useMemo(
    () =>
      createTheme(outerTheme, {
        palette: {
          mode: theme.mode,
          background: {
            default: theme.chat.bg,
            paper: theme.shell.bg,
          },
          text: {
            primary: theme.shell.textPrimary,
            secondary: theme.shell.textSecondary,
            disabled: theme.chat.dividerText,
          },
          divider: theme.shell.border,
          action: {
            hover: alpha(theme.shell.accent, 0.08),
            selected: alpha(theme.shell.accent, 0.14),
            disabled: theme.chat.dividerText,
          },
        },
      }),
    [outerTheme, theme],
  );

  return <ThemeProvider theme={scopedTheme}>{children}</ThemeProvider>;
}
